import axios, { AxiosResponse } from 'axios'
import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { ResellerGroup, ResellerGroupsQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const RESELLERGROUP_URL = `${API_URL}/admin/reseller-groups`
const GET_RESELLERGROUPS_URL = `${API_URL}/admin/reseller-groups`

const getResellerGroups = (query: string): Promise<ResellerGroupsQueryResponse | WoosatTelecomResponse<ResellerGroup[]>> => {
  return axios
    .get(`${GET_RESELLERGROUPS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<ResellerGroup[]>>) => {
      return d.data
    })
}

const getResellerGroupById = async (id: ID): Promise<ResellerGroup> => {
  try {
    const { data } = await axios.get(`${RESELLERGROUP_URL}/${id}`)
    return data?.data?.reseller_group
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
}

const createResellerGroup = (resellergroup: ResellerGroup): Promise<ResellerGroup | undefined> => {
  const formData = new FormData()
  Object.entries(resellergroup).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value.toString())
    }
  })

  return axios
    .post(RESELLERGROUP_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<ResellerGroup>) => response.data)
}

const updateResellerGroup = (resellergroup: ResellerGroup): Promise<ResellerGroup | undefined> => {
  const newFormData = new FormData()
  Object.entries(resellergroup).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      newFormData.append(key, value.toString())
    }
  })

  return axios
    .post(`${RESELLERGROUP_URL}/${resellergroup.id}`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<ResellerGroup>) => response.data)
}

const deleteResellerGroup = (resellergroupId: ID): Promise<void> => {
  return axios.delete(`${RESELLERGROUP_URL}/${resellergroupId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}

const deleteSelectedResellerGroups = (resellergroupIds: Array<ID>): Promise<void> => {
  const requests = resellergroupIds.map((id) => axios.delete(`${RESELLERGROUP_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getResellerGroups,
  deleteResellerGroup,
  deleteSelectedResellerGroups,
  getResellerGroupById,
  createResellerGroup,
  updateResellerGroup,
}
